export default __webpack_public_path__ + "static/media/empty_trash.ba1bca49.svg";